import { render, staticRenderFns } from "./DistributorProductsDialog.vue?vue&type=template&id=0b87c891"
import script from "./DistributorProductsDialog.vue?vue&type=script&lang=js"
export * from "./DistributorProductsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports